"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_notifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "1fc662e9-d6cd-4257-8d56-57d80aacfa7d",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "notifications-mid"), /*#__PURE__*/React.createElement("polyline", {
    points: "192 0 192 192 0 192 0 0",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "db8857b7-4b75-4289-a398-3900c91d0fa3",
    "data-name": "93ff4d18-3497-45db-b877-d4ab9e8b4a69",
    d: "M33.41,158.59",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 168,
    r: 4,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 168,
    r: 2.5,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 168,
    r: 1,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.22,33.91c-16.06,0-23.28,7.71-24.09,8.44-5.23,4.72-7.53,10.3-8.47,17.39l-.18,5.81-.37,11.6A104.86,104.86,0,0,1,53,118.38c-.62,1.22-1.11,2.57-1.77,3.74h0c-.43.77-.85,1.63-1.3,2.38a29.62,29.62,0,0,1-4.64,6h0c-5.63,5.64-8.26,8.65-10.3,16.13l-.81,2.67A3.77,3.77,0,0,0,38,154H154a3.77,3.77,0,0,0,3.82-4.72l-.81-2.67c-2-7.48-4.67-10.49-10.3-16.13a29.62,29.62,0,0,1-4.64-6c-.45-.75-.87-1.61-1.3-2.38-.66-1.17-1.15-2.53-1.76-3.75a104.77,104.77,0,0,1-10.15-41.22l-.36-11.64-.18-5.72c-.94-7.11-1.8-12.71-7-17.44C120.49,41.62,112.27,33.91,96.22,33.91Z",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.9,35V29.91A11.84,11.84,0,0,0,96,17.91a12,12,0,0,0-12,12V35",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }));
}

var _default = ic_notifications;
exports.default = _default;